import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import AuthorDetail from '@/components/screens/author-detail/AuthorDetail';
import { API_URL } from '@/helpers/variables';
import { IAuthorDetail } from '@/interfaces/authorDetail.interface';

interface IAuthorDetailPage {
  authorData: IAuthorDetail;
}

const AuthorDetailPage: NextPage<IAuthorDetailPage> = ({ authorData }) => {
  return <AuthorDetail authorInfo={authorData} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const authorDataRes = await fetch(`${API_URL}satellite/author/info/${id}/with_series?page=1&page_size=300&sort_reversed=false`);

  // Check fetch error
  if (!authorDataRes.ok) {
    console.table(`Error ${authorDataRes.status}. Api: ${authorDataRes.url}`);
    return {
      notFound: true,
    };
  }

  const authorData = await authorDataRes.json();

  // Check Fetched Data
  if (!authorData.base_author_data) {
    return {
      notFound: true,
    };
  }

  return { props: { authorData } };
};

export default AuthorDetailPage;
